export default () => {
	const textarea = document.querySelectorAll('textarea');

	for (const iterator of textarea) {
		iterator.style.cssText = 'height:auto;';
		iterator.style.cssText = `height:${iterator.scrollHeight}px`;
		iterator.addEventListener('keydown', e => autoSize(e));
	}

	let timer;
	let timer2;

	/** */
	const autoSize = e => {
		clearTimeout(timer);
		const el = e.target;
		timer = setTimeout(() => {
			el.style.cssText = 'height:auto;';
			el.style.cssText = `height:${el.scrollHeight}px`;
		}, 0);
	};

	window.addEventListener('resize', () => {
		clearTimeout(timer2);
		timer2 = setTimeout(() => {
			for (const iterator of textarea) {
				iterator.style.cssText = 'height:auto;';
				iterator.style.cssText = `height:${iterator.scrollHeight}px`;
			}
		}, 300);
	});
};
